let FaqAccordion = Garnish.Base.extend({
    $container: null,
    $toggle: null,
    $toggleContent: null,

    init() {
        this.$container = $('.faq-list')
        this.$toggle = this.$container.find('.toggle')
        this.$toggleContent = this.$container.find('.toggle-content')

        this.addListener(this.$toggle, 'click', this.handleToggle)
    },

    handleToggle(e) {
        e.preventDefault()

        this.$toggle.attr('aria-expanded', 'false')
        this.$toggleContent.attr('aria-hidden', 'true')

        let currentTarget = $(e.currentTarget)

        if (currentTarget.hasClass('active')) {
            currentTarget.removeClass('active')
            this.$toggleContent.slideUp()
        } else {
            this.$toggle.removeClass('active')
            this.$toggleContent.slideUp()
            currentTarget.addClass('active')
            currentTarget.attr('aria-expanded', 'true')
            currentTarget.next('.toggle-content').attr('aria-hidden', 'false').slideDown()

        }
    }
})

Garnish.$doc.ready(function () {
    if ($('.page-faqs').length > 0) {
        GG.FaqIndex = new FaqAccordion()
    }
})
